/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-console */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { once } from 'underscore';

const { host, protocol } = document.location;
const stylesheeturl = `${protocol}//${host}/src/assets/chatbot-vic.css`;

(() => {
  const e = 'bp-web-widget';
  const t = {};
  function n(t) {
    return t ? `${t}-container` : e;
  }
  function o(e) {
    return e || 'bp-widget';
  }
  function i(e, t, n = {}) {
    const o = document.createElement(e);
    Object.entries(n).forEach(([e, t]) => (o[e] = t));
    const i = document.querySelector(t);
    if (!i) throw new Error(`No element correspond to ${t}`);
    return i.appendChild(o), o;
  }
  function r(e, t) {
    const n = `bp-chat-key-${t.clientId}`;
    let i = localStorage.getItem(n);
    i ||
      ((i = (function (e) {
        const t =
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let n = '';
        for (let o = 0; o < e; o++)
          n += t.charAt(Math.floor(Math.random() * t.length));
        return n;
      })(32)),
      localStorage.setItem(n, i));
    const r = encodeURIComponent(
      JSON.stringify({
        config: { ...t, encryptionKey: i },
      }),
    );
    const a = encodeURIComponent(
      t.botConversationDescription || t.botName || 'Chatbot',
    );
    const c = `${e}/index.html?options=${r}`;
    return `<iframe id="${o(
      t.chatId,
    )}" title="${a}" frameborder="0" src="${c}" class="bp-widget-web" />`;
  }
  function a(e, t) {
    return new Proxy(t, {
      get: (t, n) =>
        t[n]
          ? t[n]
          : n === 'iframeWindow'
            ? () => {
                console.warn(
                  `No webchat with id ${e} has been initialized. \n Please use window.botpressWebChat.init first.`,
                );
              }
            : n === 'eventListener'
              ? { handler: () => {}, types: [] }
              : void 0,
      set: (e, t, n) => ((e[t] = n), !0),
    });
  }
  function c(n) {
    return t[(n = n || e)];
  }
  function s(e, t) {
    return document.querySelector(`#${e} #${t}`);
  }
  window.addEventListener('message', function ({ data: e }) {
    let t;
    let i;
    let r;
    if (
      !(function (e) {
        return e && typeof e.type === 'string' && typeof e.chatId === 'string';
      })(e)
    )
      return;
    if (e.type === 'UI.RESIZE') {
      const t = typeof e.value === 'number' ? `${e.value}px` : e.value;
      s(n(e.chatId), o(e.chatId)).style.width = t;
    }
    if (e.type === 'UI.SET-CLASS') {
      s(n(e.chatId), o(e.chatId)).setAttribute('class', e.value);
    }
    const a = c(e.chatId);
    a &&
      ((t = a.eventListener.topics) === null || void 0 === t
        ? void 0
        : t.some(t => t === '*' || t === e.type)) &&
      ((r = (i = a.eventListener).handler) === null ||
        void 0 === r ||
        r.call(i, e));
  }),
    (window.botpressWebChat = {
      init(c, d) {
        (d = d || 'body'), (c.chatId = c.chatId || e);
        const f = c.hostUrl || '';
        i('link', 'head', {
          rel: 'stylesheet',
          href: `${stylesheeturl}`,
        });
        const l = r(f, c);
        const u = n(c.chatId);
        const h = o(c.chatId);
        i('div', d, { id: u, innerHTML: l });
        const p = { iframeWindow: s(u, h).contentWindow };
        t[c.chatId]
          ? Object.assign(t[c.chatId], p)
          : (t[c.chatId] = a(c.chatId, p));
      },
      configure(e, t) {
        c(t).iframeWindow.postMessage({ action: 'configure', payload: e }, '*');
      },
      sendEvent(e, t) {
        c(t).iframeWindow.postMessage({ action: 'event', payload: e }, '*');
      },
      mergeConfig(e, t) {
        c(t).iframeWindow.postMessage(
          { action: 'mergeConfig', payload: e },
          '*',
        );
      },
      sendPayload(e, t) {
        c(t).iframeWindow.postMessage(
          { action: 'sendPayload', payload: e },
          '*',
        );
      },
      onEvent(n, o = [], i) {
        if (typeof n !== 'function')
          throw new Error(
            'EventHandler is not a function, please provide a function',
          );
        if (!Array.isArray(o))
          throw new Error('Topics should be an array of supported event types');
        const r = { eventListener: { handler: n, topics: o } };
        t[(i = i || e)] ? Object.assign(t[i], r) : (t[i] = a(i, r));
      },
    });
})();

export default once(() => {
  window.botpressWebChat.init({
    stylesheet: stylesheeturl,
    composerPlaceholder: 'Chat met Vic',
    botConversationDescription: 'Virtuele Inzetbaarheidscoach',
    botId: 'ac1f21ca-8bd1-4b97-b2c6-ed0b068c39c5',
    hostUrl: 'https://cdn.botpress.cloud/webchat/v0',
    messagingUrl: 'https://messaging.botpress.cloud',
    clientId: 'ac1f21ca-8bd1-4b97-b2c6-ed0b068c39c5',
    lazySocket: true,
    botName: 'Vic (try-out)',
    avatarUrl: 'https://i.postimg.cc/L8ntHgJ2/Dex-wit.png',
    website: 'https://www.zorgvandezaak.nl/',
    frontendVersion: 'v0',
    useSessionStorage: true,
    showBotInfoPage: true,
    enableConversationDeletion: true,
  });

  window.botpressWebChat.onEvent(
    function (event) {
      if (event.type === 'LIFECYCLE.LOADED') {
        window.botpressWebChat.sendEvent({ type: 'toggleBotInfo' });
      }
    },
    ['LIFECYCLE.LOADED'],
  );
});
